
import React, { useState } from "react";
import {
    Box,
    Grid,
    Paper,
    Typography,
} from "@mui/material";
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import ApiService from "../../functions/apiService";
import { toast } from "react-toastify";
import MyTable from "../../components/Schedule/MyTable"
const ReqComponent = () => <span style={{ color: "red" }}>*</span>;
import moment from "moment";

const ImportSchedule = () => {

    const [file, setFile] = useState(null);
    const [errors, setErrors] = useState([]);
    const [saving, setSaving] = useState(false);
    const [data , setData] = useState('');

    const handleFileChange = (e) => setFile(e.target.files[0]);

const handleSubmit = async () => {
    if (!file) {
        toast.error("Please select an Excel file!");
        return;
    }

    setSaving(true);

    try {
        const formData = new FormData();
        formData.append("file", file);

        const response = await ApiService.post("/import/schedule", formData);
        setData(response || [])
        if(response?.success){
            const formattedErrors = response?.detailed_results?.map((item, index) => ({
            ...item,
            id: index + 1,
        })) || [];

        setErrors(formattedErrors);
        toast.success("Upload complete");
        }
        

    } catch (err) {
        toast.error("Upload failed!");
    }
    setSaving(false);
};


    const columns = [
        { field: "row_number", headerName: "Row", width: 90 },
        {
            field: "date",
            headerName: "Date",
            width: 130,
            valueGetter: (params) => moment(params.row?.data?.date).format('MM/DD/YYYY'),
        },
        {
            field: "emp_name",
            headerName: "Employee Name",
            width: 180,
            valueGetter: (params) => params.row?.data?.emp_name,
        },
        {
            field: "position",
            headerName: "Position",
            width: 160,
            valueGetter: (params) => params.row?.data?.position,
        },
        {
            field: "assignment",
            headerName: "Assignment",
            width: 160,
            valueGetter: (params) => params.row?.data?.assignment,
        },
        {
            field: "start",
            headerName: "Start Time",
            width: 120,
            valueGetter: (params) => params.row?.data?.start,
        },
        {
            field: "end",
            headerName: "End Time",
            width: 120,
            valueGetter: (params) => params.row?.data?.end,
        },
        {
            field: "shift_rotation",
            headerName: "Shift Rotation",
            width: 150,
            valueGetter: (params) => params.row?.data?.shift_rotation,
        },
        { field: "status", headerName: "Status", width: 120 },
        { field: "message", headerName: "Error Message", width: 260,
            renderCell: (params) => {
                return (
                    <div style={{padding:'10px 0px'}}>
                        {params.row?.message}
                    </div>
                )
            }
        },
    ];


    return (
        <Paper style={{ padding: "2rem", marginTop: "1rem" }}>
            <Typography variant="h6" style={{ marginBottom: "15px" }}>
                Import Schedule
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={5}>
                    <Typography style={{ fontWeight: 600 }}>
                        Import Schedule File <ReqComponent />
                    </Typography>

                    <input
                        type="file"
                        accept=".xls,.xlsx"
                        onChange={handleFileChange}
                        style={{
                            marginTop: "10px",
                            border: "1px solid #ccc",
                            padding: "8px",
                            width: "100%",
                            borderRadius: "6px",
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3} style={{ display: "flex", alignItems: "end" }}>
                    <ButtonTheme
                        variant="filled"
                        color="primary"
                        className="px-5 mx-2"
                        onClick={handleSubmit}
                    >
                        {saving ? "Loading..." : "Submit"}
                    </ButtonTheme>
                </Grid>
            </Grid>

            {/* ---- Error Table Section Using MyTable ---- */}
            {errors.length > 0 && (
                <Box style={{ marginTop: "2rem" }}>
                    <Typography variant="subtitle1" style={{ marginBottom: "10px", fontWeight: 600 }}>
                        Logs -  Total rows : {data?.total_rows} , Succesfull rows : {data?.successful_count} , Failed rows : {data?.failed_count}
                    </Typography>

                    <MyTable
                        rows={errors}
                        columns={columns}
                        checkboxSelection={false}
                        hideFooter={false}    
                        perPage={50}          
                        minHeightRow="auto"
                        rowCount={errors?.length}
                    />
                </Box>
            )}

        </Paper>
    );
};

export default ImportSchedule;

